// Maps the admin-portal route first-segment -> permission module key.
// Keep in sync with backend PERMISSION_MODULES (routes/roles.py).
const SEGMENT_MODULE = {
  '': 'dashboard',
  'daily-tracker': 'dashboard',
  'revenue-tracker': 'dashboard',
  'analytics': 'analytics',
  'clinic-trends': 'analytics',
  'ai-insights': 'analytics',
  'ai-alerts': 'analytics',
  'billing-analytics': 'analytics',
  'margin-tracker': 'analytics',
  'invoices': 'invoices',
  'create-invoice': 'invoices',
  'payments': 'payments',
  'banks': 'accounting',
  'cash-ledger': 'accounting',
  'journal-entries': 'accounting',
  'chart-of-accounts': 'accounting',
  'bank-reconciliation': 'accounting',
  'financial-statements': 'reports',
  'create-sales-order': 'sales_orders',
  'lead-sources': 'masters',
  'audiologist-master': 'masters',
  'clinics-master': 'masters',
  'payment-modes': 'admin',
  'location-master': 'admin',
  'zoho-sync': 'admin',
  'settings': 'admin',
  'customers': 'customers',
  'customer-reports': 'reports',
  'discount-report': 'reports',
  'item-wise-report': 'reports',
  'invoice-report': 'reports',
  'sales-order-report': 'reports',
  'purchase-report': 'reports',
  'accounting-reports': 'reports',
  'daily-clinic-revenue': 'reports',
  'items-master': 'inventory',
  'inventory': 'inventory',
  'order-management': 'inventory',
  'transfer-orders': 'transfer_orders',
  'vendor-management': 'vendor_bills',
  'purchase-orders': 'purchase_orders',
  'vendor-bills': 'vendor_bills',
  'vendor-credit': 'vendor_bills',
  'hr': 'hr',
  'employee-master': 'hr',
  'payroll': 'hr',
  'announcements': 'hr',
  'gst': 'compliance',
  'tds': 'compliance',
  'e-invoicing': 'compliance',
  'compliance-calendar': 'compliance',
  'users': 'users_roles',
  'roles': 'users_roles',
  'team-access': 'users_roles',
  'audit-logs': 'audit_log',
};

export function moduleForPath(pathname) {
  if (!pathname) return null;
  const seg = pathname.replace(/^\/+/, '').split('/')[0];
  return SEGMENT_MODULE[seg] ?? null;
}

// Whether the user can perform `action` on `module`. Admin always can. Unknown
// (unmapped) modules are allowed so new/utility pages never get locked out.
export function canAccess(user, module, action = 'view') {
  if (!module) return true;
  if (user?.role === 'admin') return true;
  const perms = user?.permissions || {};
  return (perms[module] || []).includes(action);
}
